import { render, staticRenderFns } from "./designatedAccount.vue?vue&type=template&id=5389227a&scoped=true"
import script from "./designatedAccount.vue?vue&type=script&lang=js"
export * from "./designatedAccount.vue?vue&type=script&lang=js"
import style0 from "./designatedAccount.vue?vue&type=style&index=0&id=5389227a&prod&lang=scss"
import style1 from "./designatedAccount.vue?vue&type=style&index=1&id=5389227a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5389227a",
  null
  
)

export default component.exports